import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=dce4fd68&scoped=true&"
import script from "./AddressInput.vue?vue&type=script&lang=js&"
export * from "./AddressInput.vue?vue&type=script&lang=js&"
import style0 from "./AddressInput.vue?vue&type=style&index=0&id=dce4fd68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce4fd68",
  null
  
)

export default component.exports